import React from 'react';

import styled from 'styled-components';

import CdnImage from '~/shared/components/CdnImage';
import { AssetContainer } from '~/techstyle-shared/react-assets';
import { useBreakpoint } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const Wrapper = styled.div`
  background:
    linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('${(p) => encodeURI(p.backgroundUrl)}') center/cover no-repeat;
  min-height: 403px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${({ theme }) => theme.colors.textLight};
`;

const Inner = styled.div``;

const Title = styled.div`
  font-weight: bold;
  font-size: 30px;
  line-height: 37px;
  margin: 10px auto;
`;

const TextCopy = styled.div`
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  width: 55%;
  margin: auto;
  letter-spacing: 0.4px;
`;

const IconWrapper = styled.div`
  width: 73px;
  height: 73px;
  background: ${({ theme }) => theme.colors.palette.white};
  border-radius: 50%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function FitAppPageEarn() {
  const { isMobile } = useBreakpoint();

  return (
    <AssetContainer
      name={
        isMobile ? 'fitnessapp_content5_mobile' : 'fitnessapp_content5_desktop'
      }
    >
      {({ data: { imageFilename } }) => (
        <Wrapper backgroundUrl={imageFilename}>
          <Inner>
            <IconWrapper>
              <CdnImage
                path="exerciseearn-icon.png"
                localize="fitness_app"
                alt=""
              />
            </IconWrapper>
            <Title>
              <FormattedMessage
                defaultMessage="EXERCISE AND EARN"
                id="fitness_app.section_6_title"
              />
            </Title>
            <TextCopy>
              <FormattedMessage
                defaultMessage="<b>UNLOCK DISCOUNTS, POINTS AND MORE</b> WHEN YOU COMPLETE OUR CHALLENGES. PLUS, USE OUR CHALLENGES AS MOTIVATION TO ACHIEVE YOUR NEXT GOAL!"
                id="fitness_app.section_6_copy"
              />
            </TextCopy>
          </Inner>
        </Wrapper>
      )}
    </AssetContainer>
  );
}
